<template>
    <v-dialog v-model="modal" :scrim="false" width="900">
        <v-card>
            <component :is="component" :product="entry" book-disabled>
                <template v-slot:price="{offer}">
                    <tour-offer-delta-button :offer="offer" :offer-key="offerKey" :entry-name="entry.entryName" />
                </template>
            </component>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
    import {Vue, Component, Prop} from 'vue-facing-decorator'
    import {EventBus, SHOW_TOUR_CAR_INFO} from '@/utils/event-bus'
    import TourOfferDeltaButton from '@/components/tours/search/TourOfferDeltaButton.vue'
    import CarOfferCard from '~src/components/carsRent/search/offers/CarOfferCard.vue'
    import CarOfferCardMobile from '~src/components/carsRent/search/offers/CarOfferCardMobile.vue'

    @Component({
        components: {
            CarOfferCard,
            CarOfferCardMobile,
            TourOfferDeltaButton,
        },
    })
    export class TourCarInfoModal extends Vue {
        @Prop({required: true}) searchRequest

        modal = false
        entry = {}
        offerKey = null

        mounted() {
            EventBus.$on(SHOW_TOUR_CAR_INFO, this.showModal)
        }

        beforeUnmount() {
            EventBus.$off(SHOW_TOUR_CAR_INFO, this.showModal)
        }

        async showModal({entry, offerKey}) {
            this.entry = entry
            this.offerKey = offerKey
            this.modal = true
        }

        get component() {
            return !this.$breakpoint.smAndDown
                ? resolveComponent('CarOfferCard')
                : resolveComponent('CarOfferCardMobile')
        }
    }

    export default TourCarInfoModal
</script>
